"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var TourActions = {
  getSummary: function getSummary(data) {
    return global.request.post('tours/summary', data, {});
  }
};
var _default = exports["default"] = TourActions;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJUb3VyQWN0aW9ucyIsImdldFN1bW1hcnkiLCJkYXRhIiwiZ2xvYmFsIiwicmVxdWVzdCIsInBvc3QiLCJfZGVmYXVsdCIsImV4cG9ydHMiXSwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9saWJyYXJ5L3NyYy1ib29rL2NsaWVudC9tb2R1bGVzL1RvdXIvVG91ckFjdGlvbnMuanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgVG91ckFjdGlvbnMgPSB7XHJcbiAgICBnZXRTdW1tYXJ5OiAoZGF0YSkgPT4gZ2xvYmFsLnJlcXVlc3QucG9zdCgndG91cnMvc3VtbWFyeScsIGRhdGEsIHt9KSxcclxufVxyXG5cclxuZXhwb3J0IGRlZmF1bHQgVG91ckFjdGlvbnNcclxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxJQUFNQSxXQUFXLEdBQUc7RUFDaEJDLFVBQVUsRUFBRSxTQUFaQSxVQUFVQSxDQUFHQyxJQUFJO0lBQUEsT0FBS0MsTUFBTSxDQUFDQyxPQUFPLENBQUNDLElBQUksQ0FBQyxlQUFlLEVBQUVILElBQUksRUFBRSxDQUFDLENBQUMsQ0FBQztFQUFBO0FBQ3hFLENBQUM7QUFBQSxJQUFBSSxRQUFBLEdBQUFDLE9BQUEsY0FFY1AsV0FBVyJ9